import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import Stepper from "../common/Stepper";
import CampaignManager from "./CampaignManager";
import SharePopup from "../common/SharePopup";

/*
PROPS
- stepperIndex
- title
- onSave
*/

class CampaignPageHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      needSharePopup: false,
    };
  }
  render() {
    const stepperIndex = CampaignManager.checkCampaignSent()
      ? this.props.stepperIndex - 1
      : this.props.stepperIndex;
    return (
      <div className="parent-width border-box column position-relative z-index-2">
        <div className="row justify-content-between">
          <DKLabel text={this.props.title} className="fw-m fs-l" />
          {this.getButtons()}
        </div>
        <div className="row justify-content-center">
          <Stepper
            data={CampaignManager.getAllCreationSteps()}
            currentIndex={stepperIndex}
          />
        </div>
      </div>
    );
  }

  getButtons() {
    return (
      <div className="row" style={{ width: "auto" }}>
        {CampaignManager.directLinkExists() && (
          <DKButton
            title="Share"
            className="bg-white border-m ml-r unselectable"
            icon={DKIcons.ic_share}
            onClick={() => {
              this.showSharePopup();
            }}
          />
        )}
        {this.props.onSave && (
          <DKButton
            title="Save & Proceed"
            className="bg-app text-white ml-r unselectable"
            onClick={() => {
              this.props.onSave();
            }}
          />
        )}
        {this.state.needSharePopup && this.getSharePopup()}
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSharePopup() {
    return (
      <SharePopup
        style={{ top: 35, right: 0 }}
        // embedCode='<iframe frameborder="0" style="height:500px;width:99%;border:none;" src="https://forms.deskera.com/form/ContentMarketingWorkshop/formperma/V0HqLCXF3AC0zw4BjDaqAgGZMtFQrRWkHU0hTwUJSj0"></iframe>'
        directLink={CampaignManager.getDirectLink()}
        onClose={this.hideSharePopup}
      />
    );
  }

  showSharePopup = () => {
    this.setState({ needSharePopup: true });
  };

  hideSharePopup = () => {
    this.setState({ needSharePopup: false });
  };
}

export default CampaignPageHeader;
